// facebookConfig.js
export const initFacebookSDK = () => {
  return new Promise(resolve => {
      window.FB.init({
          appId: '1935672896896952',
          // appId: '1528346657815641',
          cookie: true,
          xfbml: true,
          version: 'v21.0' // เปลี่ยนจาก v17.0 เป็น v16.0
        });

    // โหลด SDK
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  });
};
